// Couleurs officielles Manrina
const MANRINA_COLORS = {
  orange: 'rgb(var(--c-primary))',
  vert: 'rgb(var(--c-green))',
  creme: 'rgb(var(--c-creme))',
}

// ============================================
// PARTICULES ÉTOILES (comme le portail)
// ============================================
export function StarParticles() {
  const stars = []
  for (let i = 0; i < 25; i++) {
    const isOrange = i % 2 === 0
    const variants = ['', 'drift', 'star-shape']
    const variant = variants[i % 3]
    stars.push({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      color: isOrange ? MANRINA_COLORS.orange : MANRINA_COLORS.vert,
      duration: `${3 + Math.random() * 5}s`,
      delay: `${Math.random() * 4}s`,
      variant,
    })
  }

  return (
    <div className="star-particles">
      {stars.map((star) => (
        <div
          key={star.id}
          className={`star-particle ${star.variant}`}
          style={{
            left: star.left,
            top: star.top,
            background: star.color,
            color: star.color,
            '--duration': star.duration,
            '--delay': star.delay,
          }}
        />
      ))}
    </div>
  )
}

// ============================================
// ÉMOJIS FLOTTANTS (version légère pour la page connexion)
// ============================================
const ORBIT_EMOJIS = ['🥭', '🥬', '🍞', '🧺', '🍯', '🌺', '🥥', '🍌']

export function FloatingEmojisLight() {
  const emojis = ORBIT_EMOJIS.map((emoji, i) => ({
    emoji,
    left: `${10 + (i * 11)}%`,
    top: `${15 + Math.random() * 70}%`,
    duration: `${12 + Math.random() * 6}s`,
    delay: `${i * 0.4}s`,
    variant: ['', 'alt', 'bounce'][i % 3],
    size: '1.5rem',
  }))

  return (
    <div className="floating-emojis-container">
      {emojis.map((item, i) => (
        <span
          key={i}
          className={`floating-emoji ${item.variant}`}
          style={{
            left: item.left,
            top: item.top,
            fontSize: item.size,
            '--duration': item.duration,
            '--delay': item.delay,
          }}
        >
          {item.emoji}
        </span>
      ))}
    </div>
  )
}

// ============================================
// PARTICULES WEB3
// ============================================
export function Web3Particles() {
  const particles = Array.from({ length: 12 }, (_, i) => ({
    id: i,
    left: `${8 + (i * 8)}%`,
    delay: `${i * 0.5}s`,
    color: i % 2 === 0 ? MANRINA_COLORS.orange : MANRINA_COLORS.vert,
  }))

  return (
    <div className="particles">
      {particles.map(p => (
        <div
          key={p.id}
          className="particle"
          style={{ left: p.left, animationDelay: p.delay, backgroundColor: p.color }}
        />
      ))}
    </div>
  )
}
